/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useEffect } from "react";
import HomePageMeta from "./HomePageMeta";
import Layout from "../../../Layouts/Layout";
import TrustSection from "../../../../components/Sections/Generic/TrustSection/TrustSection";
import PartnersSection from "../../../../components/Sections/Generic/PartnersSection/PartnersSection";
import { useLocation, useNavigate } from "react-router";
import MainTeaser from "../../../../components/Homepage/MainTeaser";
import ServiceTeaser from "../../../../components/Teaser/ServiceTeaser";
import GreyBackgroundWrapper from "../../../../components/BackgroundWrapper/GreyBackgroundWrapper";
import { modalview } from "../../../../services/useTracker";
import { logout } from "../../../../store/login/actions";
import AreaSelection from "../../../../components/AreaSelection/AreaSelection";

const HomePage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    logout();
  }, []);

  const handleOpenLoginLayer = () => {
    navigate(location.pathname, {
      state: {
        loginModalOpen: "loginIcon",
      },
    });
    modalview("Login Layer Modal");
  };

  return (
    <Layout backgroundType={"homepage"}>
      <HomePageMeta />
      <MainTeaser handleOpenLoginLayer={handleOpenLoginLayer} />
      <GreyBackgroundWrapper>
        <AreaSelection />
        <ServiceTeaser />
      </GreyBackgroundWrapper>
      <TrustSection />
      <PartnersSection />
    </Layout>
  );
};

export default HomePage;
